import { render, staticRenderFns } from "./VersionHistoryCreate.vue?vue&type=template&id=0fad0d05"
import script from "./VersionHistoryCreate.vue?vue&type=script&lang=js"
export * from "./VersionHistoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports